import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import {
  MANAGE_MEMBER_PERMISSION_MUTATION,
  SETTINGS_USER_DETAILS_TO_MANAGE_PERMISSION,
} from '../../graphql';
import {
  ManageMembersRequestModel,
  SettingsMembersPermissionsWithAccessAreaDataModel,
  SubmitManageMembersPermissionsResponse,
} from '../../models';

@Injectable({ providedIn: 'root' })
export class SettingsUserDetailsToManagePermission {
  private clientName = APOLLO_CLIENT_NAMES.contact;

  constructor(private readonly apollo: Apollo) {}

  getUserDetailsToManagePermission(
    memberEmail: string,
    accountDnvId: string | null,
    skipLoading?: boolean,
  ): Observable<SettingsMembersPermissionsWithAccessAreaDataModel> {
    const fieldName =
      getQueryRootFieldName(SETTINGS_USER_DETAILS_TO_MANAGE_PERMISSION) ||
      'getUserDetailsTomanagePermission';

    let customHeaders = new HttpHeaders();

    if (skipLoading) {
      customHeaders = customHeaders.set('SKIP_LOADING', 'true');
    }

    return this.apollo
      .use(this.clientName)
      .query({
        query: SETTINGS_USER_DETAILS_TO_MANAGE_PERMISSION,
        variables: {
          memberEmail,
          accountDNVId: accountDnvId,
        },
        fetchPolicy: 'no-cache',
        context: {
          headers: customHeaders,
        },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.getUserDetailsTomanagePermission),
      );
  }

  submitManageMembersPermissions(
    manageMemberRequest: ManageMembersRequestModel,
  ): Observable<SubmitManageMembersPermissionsResponse> {
    const fieldName =
      getQueryRootFieldName(MANAGE_MEMBER_PERMISSION_MUTATION) ||
      'managememberpermission';

    return this.apollo
      .use(this.clientName)
      .mutate({
        mutation: MANAGE_MEMBER_PERMISSION_MUTATION,
        variables: {
          manageMemberRequest,
        },
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((results: any) => results?.data?.managememberpermission),
      );
  }
}
